import type { UserMenuItem } from '@mercadoni/stark-ui';

import type { UserMenuAction } from '../../core/interfaces';

/** User-menu entry whose label is a translation key, resolved when the menu is built. */
export interface UserMenuEntry {
  id: UserMenuAction;
  labelKey: string;
  icon: string;
  danger?: boolean;
  dividerBefore?: boolean;
}

export const USER_MENU_ITEMS: UserMenuEntry[] = [
  { id: 'language', labelKey: 'layout.userMenu.language', icon: 'globe' },
  { id: 'logout', labelKey: 'layout.userMenu.logout', icon: 'log-out', danger: true, dividerBefore: true },
];

/**
 * Builds the stark-ui user-menu items with their labels resolved in the active language.
 *
 * @param translate Resolves a translation key to text (`TranslocoService.translate`).
 */
export function buildUserMenuItems(translate: (key: string) => string): UserMenuItem[] {
  return USER_MENU_ITEMS.map(({ labelKey, ...item }) => ({ ...item, label: translate(labelKey) }));
}
